export default __webpack_public_path__ + "static/media/reims7.4da074ac.jpg";